import { RemoteLoadUser } from '../../../data/usecases/user/remote-load-user'
import { RemoteCreateUser } from '../../../data/usecases/user/remote-user'
import { RemoteWithoutAuth } from '../../../data/usecases/user/remote-no-auth'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeLoadMeUser = (): RemoteLoadUser => {
  return new RemoteLoadUser('/me', makeAxiosHttpClient())
}

export const makeCurrentUser = (): RemoteLoadUser => {
  return new RemoteLoadUser('/players/current', makeAxiosHttpClient())
}

export const makeUser = (id:number): RemoteLoadUser => {
  return new RemoteLoadUser(`/players/${id}`, makeAxiosHttpClient())
}

export const checkForSignUp = (): RemoteCreateUser => {
  return new RemoteCreateUser('/public/game/check', makeAxiosHttpClient())
}

export const createUser = (): RemoteCreateUser => {
  return new RemoteCreateUser('/public/user/create', makeAxiosHttpClient())
}

export const checkGames = (): RemoteLoadUser => {
  return new RemoteLoadUser('/players/games', makeAxiosHttpClient())
}

export const makeCurrentUserByPlayer = (id: number): RemoteLoadUser => {
  return new RemoteLoadUser(`/players/set-current/${id}`, makeAxiosHttpClient())
}

export const createUserByTeam = (): RemoteCreateUser => {
  return new RemoteCreateUser('/public/user/create', makeAxiosHttpClient())
}

export const checkGame = (token: string): RemoteLoadUser => {
  return new RemoteLoadUser(`/public/check/game/${token}`, makeAxiosHttpClient())
}

export const checkTeam = (token: string): RemoteLoadUser => {
  return new RemoteLoadUser(`/public/check/team/${token}`, makeAxiosHttpClient())
}

export const userActivation = (): RemoteCreateUser => {
  return new RemoteCreateUser('/public/user/activation', makeAxiosHttpClient())
}

export const createUserByLink = (): RemoteCreateUser => {
  return new RemoteCreateUser('/public/user/create_accounts', makeAxiosHttpClient())
}

export const setTeamOrGame = (): RemoteCreateUser => {
  return new RemoteCreateUser('/user/set_game', makeAxiosHttpClient())
}

export const userTokenUpdate = (): RemoteCreateUser => {
  return new RemoteCreateUser('/public/user/token_update', makeAxiosHttpClient())
}

export const createUserByLinkSSO = (): RemoteWithoutAuth => {
  return new RemoteWithoutAuth('/public/user/sso_create', makeAxiosHttpClient())
}

export const disableNotification = (): RemoteCreateUser => {
  return new RemoteCreateUser('/public/user/disable_notification', makeAxiosHttpClient())
}

export const clickedNotification = (): RemoteCreateUser => {
  return new RemoteCreateUser('/public/user/clicked_on_notification', makeAxiosHttpClient())
}
